import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnInit, inject } from '@angular/core';
import { RouterLink } from '@angular/router';
import { Observable } from 'rxjs';

import { CategoryContextDirective } from 'ish-core/directives/category-context.directive';
import { CategoryContextFacade } from 'ish-core/facades/category-context.facade';
import { CategoryView } from 'ish-core/models/category-view/category-view.model';
import { CategoryRoutePipe } from 'ish-core/routing/category/category-route.pipe';
import { CategoryImageComponent } from 'ish-shared/components/category/category-image/category-image.component';

/**
 * The Category Tile Component renders a category tile with the image of the
 * category using {@link CategoryImageComponent}.
 *
 * @example
 * <ish-category-tile [categoryUniqueId]="category"></ish-category-tile>
 */
@Component({
  selector: 'ish-category-tile',
  templateUrl: './category-tile.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RouterLink, CategoryImageComponent, AsyncPipe, CategoryRoutePipe, CategoryContextDirective],
})
export class CategoryTileComponent implements OnInit {
  private categoryContext = inject(CategoryContextFacade);
  /**
   * The Category to render a tile for
   */
  //readonly categoryUniqueId = input.required<string>();
  category$: Observable<CategoryView>;

  ngOnInit() {
    this.category$ = this.categoryContext.select('category');
  }
}
